// is needed in 2 components (Counter and ActionsBar) and Counter is positioned absolute
// so if this value changes the position is changing as well
export const actionBarPx = [2, 2, 3.5];
